import { DocumentQuickViewModalForm } from "./DocumentQuickViewModalForm"

const DocumentQuickViewModalFormWrapper = () => {
    return (<DocumentQuickViewModalForm />)
}

export { DocumentQuickViewModalFormWrapper }